import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrowsdown",
  "use": "icon-arrowsdown-usage",
  "viewBox": "0 0 9 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 9 13\" id=\"icon-arrowsdown\">\r<path fill-rule=\"evenodd\" fill=\"rgb(220, 223, 230)\" d=\"M8.812,8.775 L4.970,12.783 C4.858,12.892 4.631,13.000 4.518,13.000 C4.292,13.000 4.179,12.892 4.067,12.783 L0.225,8.775 C-0.001,8.558 -0.001,8.233 -0.001,8.017 C0.112,7.800 0.338,7.583 0.677,7.583 L2.951,7.583 L2.951,0.382 C2.951,0.171 3.130,-0.000 3.350,-0.000 L5.648,-0.000 C5.868,-0.000 6.046,0.171 6.046,0.382 L6.046,7.583 L8.360,7.583 C8.585,7.583 8.925,7.800 8.925,8.017 C9.037,8.233 9.037,8.558 8.812,8.775 Z\" />\r</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrowsdown.svg
// module id = IC9F
// module chunks = 127